<template>
  <router-link :to="{ path: '/'}" class="site-title">
    <h1 ref="title" :style="titleStyle">{{text}}</h1>
  </router-link>  
</template>

<script>
  import {TweenMax, Power3} from 'gsap'
  import SplitText from '#/script/SplitText'

  export default {
    name: 'site-title',
    props: {
      text: {
        type: String,
        default: 'Jason Jun'
      },
      textColor: {
        type: String,
        default: '#222'
      },
      textDelay: {
        type: Number,
        default: 0
      }
    },
    computed: {
      titleStyle () {
        return 'color: ' + this.textColor
      }
    },
    mounted () {
      // Site title animate in
      const titleSplit = new SplitText(this.$refs.title, {type: 'words'})
      TweenMax.staggerFrom(
        titleSplit.words,
        1,
        {
          y: 100,
          ease: Power3.easeOut,
          delay: this.textDelay,
          onComplete: () => {
            titleSplit.revert()
          }
        },
        0.1
      ) // TweenMax
    }
  }
</script>

<style lang="scss" scoped>
  h1 {
    flex-grow: 0;
    overflow: hidden;
    display: inline-block;
    transition: opacity 0.1s linear;

    &:hover {
      opacity: 0.85;
    }
  }

  .site-title {
    display: inline-block;
    margin-top: 100px;

    @include device(tablet) {
      margin-top: 80px;
    }

    @include device(mobile) {
      margin-top: 60px;
    }

    & h1 {
      display: inline-block;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/SiteTitle.vue